export default {"theme":{"dark":false,"themes":{"dark":{},"light":{"primary":"#1976D2","secondary":"#80CBC4","accent":"#00BFA5","error":"#FF5252","info":"#2196F3","success":"#4CAF50","warning":"#FFC107"}}}}
